import { Button, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";
import SmallDialog from "@entrilia/shared/components/SmallDialog";
import NoAccessLockIcon from "@entrilia/shared/icons/NoAccessLockIcon";

interface Props {
  open: boolean;
  onClose: () => void;
}

const ImpersonationBlockedDialog = ({ open, onClose }: Props) => (
  <SmallDialog open={open} onClose={onClose}>
    <DialogTitle>Action Not Available</DialogTitle>
    <DialogCloseButton onClick={onClose} />
    <DialogContent>
      <Stack spacing={2} sx={{ alignItems: "center" }}>
        <NoAccessLockIcon sx={{ width: 80, height: 80 }} />
        <Stack spacing={0.5} sx={{ alignItems: "center" }}>
          <Typography variant="h6">You&apos;re viewing the portal as a contact</Typography>
          <Typography color="textSecondary" sx={{ textAlign: "center" }}>
            Everything the contact sees is visible to you, but actions that create or change data are unavailable in
            this view. Nothing you do here changes what the contact sees.
          </Typography>
        </Stack>
      </Stack>
    </DialogContent>
    <DialogButtons>
      <Button variant="contained" onClick={onClose}>
        Close
      </Button>
    </DialogButtons>
  </SmallDialog>
);

export default ImpersonationBlockedDialog;
